module.exports = __webpack_public_path__ + "static/media/chatarra_electronica.9991c19d.jpg";